var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1139 1.86431C10.1028 1.03418 8.86887 0.52158 7.56722 0.390976V1.73764C8.54055 1.85764 9.42722 2.24431 10.1672 2.81764L11.1139 1.86431ZM12.1872 6.35764H13.5339C13.4006 5.01764 12.8672 3.79764 12.0606 2.81098L11.1072 3.75764C11.6953 4.51094 12.0685 5.40938 12.1872 6.35764ZM11.1072 10.291L12.0606 11.2443C12.8896 10.2326 13.402 8.99898 13.5339 7.69764H12.1872C12.0672 8.64354 11.6941 9.5395 11.1072 10.291ZM7.56722 12.311V13.6576C8.90722 13.5243 10.1272 12.991 11.1139 12.1843L10.1606 11.231C9.42722 11.8043 8.54055 12.191 7.56722 12.311ZM7.56722 7.02431V3.69098H6.23389V7.02431H3.56722L6.90055 10.3576L10.2339 7.02431H7.56722ZM6.23389 12.311V13.6576C2.86722 13.3243 0.233887 10.4843 0.233887 7.02431C0.233887 3.56431 2.86722 0.724309 6.23389 0.390976V1.73764C3.60055 2.06431 1.56722 4.30431 1.56722 7.02431C1.56722 9.74431 3.60055 11.9843 6.23389 12.311Z",
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.e9471eab1032e69805ebab8b45873112.svg";
export { ForwardRef as ReactComponent };